import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { formatSaleUnitCount } from 'hooks/useSaleUnitPlural'

interface Props {
  rooms?: Array<App.RoomOccupants>
  isFlightEnabled: boolean
  duration: number
  shouldDisplayRoom: boolean
  shouldDisplayFlight?: boolean
  saleUnit: string
}

function MobileMultipleRoomsDurationLabel(props: Props) {
  const {
    rooms,
    isFlightEnabled,
    duration,
    shouldDisplayRoom = false,
    shouldDisplayFlight = true,
    saleUnit,
  } = props
  const intl = useIntl()
  const roomCount = rooms?.length || 0

  const roomCountText = formatSaleUnitCount(intl, saleUnit, roomCount)

  let resultText: string
  if (shouldDisplayRoom && isFlightEnabled) {
    resultText = intl.formatMessage(
      {
        id: 'kEfYudslEw',
        defaultMessage: '{duration, plural, one {# night} other {# nights}}, {roomCountText} + flights from',
        description: 'Duration label with room count and flights, e.g. "3 nights, 2 rooms + flights from"',
      },
      { duration, roomCountText },
    )
  } else if (shouldDisplayRoom) {
    resultText = intl.formatMessage(
      {
        id: '5uXu2rStDO',
        defaultMessage: '{duration, plural, one {# night} other {# nights}}, {roomCountText} from',
        description: 'Duration label with room count, e.g. "3 nights, 2 rooms from"',
      },
      { duration, roomCountText },
    )
  } else if (isFlightEnabled) {
    resultText = intl.formatMessage(
      {
        id: 'WGGCx18Isj',
        defaultMessage: '{duration, plural, one {# night} other {# nights}} + flights from',
        description: 'Duration label with flights, e.g. "3 nights + flights from"',
      },
      { duration },
    )
  } else {
    resultText = intl.formatMessage(
      {
        id: 'KdD+mGrfOy',
        defaultMessage: '{duration, plural, one {# night} other {# nights}} from',
        description: 'Duration label, e.g. "3 nights from"',
      },
      { duration },
    )
  }

  return <>
    {isFlightEnabled && shouldDisplayFlight && <FormattedMessage
      id="NaRqm3fhyz"
      defaultMessage="{icon} {resultText}"
      description="Duration label with flight icon"
      values={{
        icon: <LinePlaneDepartureIcon />,
        resultText,
      }}
    />}
    {!isFlightEnabled && <>{resultText}</>}
  </>
}

export default withOfferPageAndReduxState((state, _) => ({
  duration: state.duration,
  rooms: state.rooms,
  isFlightEnabled: state.flights,
  saleUnit: state.offer?.saleUnit || 'room',
}), MobileMultipleRoomsDurationLabel)
